import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

export interface Toast {
  title: string
  message: string
  time?: number
  error?: boolean
  variant?: string
}

export interface ToastInner extends Toast {
  id: number
}

export const useToastStore = defineStore('toast', () => {
  const count = ref(0),
    toasts = ref<ToastInner[]>([])

  function pushToast(toast: Toast) {
    toasts.value.push({ ...toast, id: count.value++ })
  }
  function delToast(id: number) {
    toasts.value = toasts.value.filter((p) => p.id !== id)
  }

  return {
    count,
    toasts: readonly(toasts),
    pushToast,
    delToast
  }
})
